import {
  UPDATE_COMPANY_SUCCEEDED,
  REMOVE_WORD_CLOUD_REQUEST,
  REMOVE_WORD_CLOUD_SUCCEEDED,
  REMOVE_WORD_CLOUD_FAILED,
  SUBMIT_WORD_CLOUD_REQUEST,
  SUBMIT_WORD_CLOUD_SUCCEEDED,
  SUBMIT_WORD_CLOUD_FAILED
} from '../actions/companyActions'

const initialState = {
  id: null,
  submittingWordCloud: false
}

export default function company(state = initialState, action) {
  switch (action.type) {
    case UPDATE_COMPANY_SUCCEEDED:
      return { ...state, ...action.response }
    case REMOVE_WORD_CLOUD_SUCCEEDED:
      return {
        ...state,
        submittingWordCloud: false,
        wordCloud: {}
      }
    case REMOVE_WORD_CLOUD_REQUEST:
    case SUBMIT_WORD_CLOUD_REQUEST:
      return { ...state, submittingWordCloud: true }
    case SUBMIT_WORD_CLOUD_SUCCEEDED:
      return {
        ...state,
        wordCloud: action.wordCloud,
        submittingWordCloud: false
      }
    case REMOVE_WORD_CLOUD_FAILED:
    case SUBMIT_WORD_CLOUD_FAILED:
      return { ...state, submittingWordCloud: false }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../src/reducers/company.js